// @ts-nocheck
import React, { useEffect } from 'react';

export const YandexTGOBlock = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.yaContextCb) window.yaContextCb = [];

      window.yaContextCb.push(() => {
        window.Ya?.Context?.AdvManager?.render({
          blockId: 'R-A-16691543-1',
          renderTo: 'yandex_rtb_R-A-16691543-1',
        });
      });

      // eslint-disable-next-line no-console
      console.log(window.yaContextCb);
    }
  }, []);

  return (
    <>
      {/* eslint-disable-next-line no-console */}
      {typeof window !== 'undefined' && console.log(window.yaContextCb)}
      <div id="yandex_rtb_R-A-16691543-1" style={{ maxHeight: '230px', width: '100%' }} />
    </>
  );
};
